export default {
    name: 'auth',
    component: () => import(/* webpackChunkName: "Auth-Layout" */ '@/modules/auth/layouts/AuthLayout.vue'),
    children: [
        {
            path: 'login',
            name: 'login',
            component: () => import(/* webpackChunkName: "Auth-login" */ '@/modules/auth/views/Login.vue'),
        }
    ]
}